import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { BillingRecurringTypes } from 'app/models/ss-api/responses/upgradable.products.response';
import { DashboardLicenseResponse } from 'app/models/ss-api/responses/dashboard.license.response';
import { SelectItem } from 'primeng/api';
import Swal from 'sweetalert2';
import { ssApiService } from 'app/services/ss-api.service';
import { ReactivateRequest } from '../../models/ss-api/requests/reactivate.request';
import { ReactivateSimulationResponse } from '../../models/ss-api/responses/reactivate.simulation.response';
import { CreditCardResponseArray } from '../../models/ss-api/responses/credit.card.response';
import { GlobalServices } from '../../services/global.service';
import { PublicOrderProductsResponseArray, PublicOrderProductsResponse } from '../../../app/models/ss-api/responses/public.order.products.response';
import { ReactivateSimulationRequestv2 } from 'app/models/ss-api/requests/reactivate.simulation.request.v2';
import { ReactivateSimulationResponsev2 } from 'app/models/ss-api/responses/reactivate.simulation.response.v2';
import { ReactivateRequestv2 } from 'app/models/ss-api/requests/reactivate.request.v2';
import * as moment from 'moment';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MemberProfile } from 'app/models/domain/member.profile';

export interface IReactivateLicenseDialogModel {
  title: string;
  License: DashboardLicenseResponse;
  CreditCards: SelectItem[];
  CameFromAdd: boolean;
  Products: PublicOrderProductsResponseArray;
}

@Component({
  selector: 'reactivate-license-dialog',
  templateUrl: './reactivate-license-dialog.component.html',
  styleUrls: ['./reactivate-license-dialog.component.scss'],

})
export class ReactivateLicenseDialogComponent implements OnInit {
  // @ViewChild('container', {static: false}) container: ElementRef;

  IsBusy: boolean = false;

  License: DashboardLicenseResponse;

  // VARIABLES
  isBusy: boolean = false;

  setUpFee: boolean = false;

  CameFromAdd: boolean = false;
  Products: PublicOrderProductsResponseArray;
  SelectedProduct: PublicOrderProductsResponse = new PublicOrderProductsResponse();
  SelectedBillingCycle: BillingRecurringTypes;
  isYearly: boolean;
  SelectedPrice: number;
  SelectedSetupFee: number;
  PriceDue: number;
  ProductSelected: boolean;
  IsYardSelected: boolean;
  DisableYard: boolean;
  IsInCycle: boolean;
  memberProfile: MemberProfile;
  designerName: string;

  // VARIABLES FROM INTERFACE
  title: string;
  LicenseKey: string;
  FirstName: string;
  LastName: string;
  Email: string;

  BillingDate: Date = new Date();

  Initals: string = '';

  PurchaseDisabled: boolean = true;

  includeSetupFee: boolean = false;

  simulationResponse: ReactivateSimulationResponsev2 = new ReactivateSimulationResponsev2;

  // CREDIT CARDS
  showAddCreditCard: boolean = false;
  CreditCards: SelectItem[];
  SelectedCreditCard: number;
  DesignerFieldsHidden: boolean = true;
  DesignerName: string;
  DesignerEmail: string;

  Credit: number = 0;

  Item: any = {
    Name: 'VIP3D',
    BillingCycle: BillingRecurringTypes.Monthly,
    Price: '500.00'
  };

  AssignmentOptions: SelectItem[];
  KeyAssignment: SelectItem;

  result: any;

  currentModalStep: number = 1;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private api: ssApiService, private gb: GlobalServices
  ) {
  }

  ngOnInit() {
    this.title = this.config.data.title;
    this.License = this.config.data.License;
    this.CreditCards = this.config.data.CreditCards;
    this.CameFromAdd = this.config.data.CameFromAdd;
    this.Products = this.config.data.Products;
    this.memberProfile = this.config.data.memberProfile;
    this.designerName = this.config.data.designerName;
    this.setRequireSetupDate();
    this.GetCredit();

    this.AssignmentOptions = [
      { label: this.designerName || 'Prior User', value: 0 },
      { label: `Me: Only ${this.memberProfile.Firstname} ${this.memberProfile.Lastname} will have access`, value: 1 },
      { label: 'New Designer', value: 2 }
    ];

    this.KeyAssignment = this.AssignmentOptions[0];

    setTimeout(() => {
      let productID = Number(localStorage.getItem('cartProductID'));
      let billingCycle = Number(localStorage.getItem('cartBillingCycle'));
      let yard = Boolean(localStorage.getItem('cartHasYard'));

      if (productID && billingCycle) {
        let product = this.Products.filter(product => product.ProductID == productID)[0];
        this.SetSelectedProduct(product, billingCycle);
        this.SelectedBillingCycle = billingCycle;
        this.isYearly = this.SelectedBillingCycle == BillingRecurringTypes.Yearly;
      } else {
        this.SelectedBillingCycle = this.License.Recurring;
        this.isYearly = this.SelectedBillingCycle == BillingRecurringTypes.Yearly;
        this.SetSelectedProduct(this.Products.filter(product => product.Name == this.License.ProductName)[0], this.License.Recurring);
      }

      if (this.CreditCards) {
        this.SelectedCreditCard = this.CreditCards[0].value;
      }


    }, 250);
  }

  close() {
    this.ref.close();
  }



  YardAvailable(product: PublicOrderProductsResponse) {

    if (product.YardAddon == null || product.YardAddon == undefined)
      return false;

    var isDevPublic = this.gb.IsDevPublic();
    var isLocal = this.gb.IsLocal();

    //console.log("Item: ", product.Name);
    //console.log("YardVisiblePublic: ", product.YardVisiblePublic);
    //console.log("isDevPublic: ", isDevPublic);
    //console.log("isLocal: ", isLocal);

    if (!product.YardVisiblePublic && (!isDevPublic && !isLocal))
      return false;

    // ok
    return true;
  }


  setRequireSetupDate() {
    let requireSetupDate = new Date(this.License.NextBillingDate);
    requireSetupDate.setDate(requireSetupDate.getDate() + 30);
    if (new Date() > requireSetupDate) {
      this.includeSetupFee = true;
    }
  }

  simulateReactivation() {
    this.isBusy = true;

    let request: ReactivateSimulationRequestv2 = {
      LicenseKey: this.License.Key,
      IncludeYARD: this.IsYardSelected,
      NewProductID: this.SelectedProduct.ProductID,
      BillingCycle: this.SelectedBillingCycle
    };

    let disposable = this.api.ProductsReactivateSimulationv2(request).subscribe(response => {
      console.log("reactresponse", response);
      this.simulationResponse = response.Data;
      this.isBusy = false;

      if (response.Data && response.Data.ProductPrice <= 0) {
        this.IsInCycle = true;
      }
      this.CheckPurchaseDisabled();
      disposable.unsubscribe();
    }, error => {
      this.isBusy = false;
    });

  }

  MonthlySelected(product: PublicOrderProductsResponse) {
    this.SetSelectedProduct(product, BillingRecurringTypes.Monthly);
  }

  YearlySelected(product: PublicOrderProductsResponse) {
    this.SetSelectedProduct(product, BillingRecurringTypes.Yearly);
  }

  billingCycleChange(e) {
    this.SelectedBillingCycle = e.checked ? BillingRecurringTypes.Yearly : BillingRecurringTypes.Monthly;
    // this.simulateReactivation();
  }

  billingCylceIsYearly()
  {
    return this.SelectedBillingCycle == BillingRecurringTypes.Yearly;
  }

  AssignmentChanged(e) {
    this.KeyAssignment = this.AssignmentOptions.find(option => option.value === e.value);
    this.DesignerFieldsHidden = this.KeyAssignment.value != 2;
    if (this.DesignerFieldsHidden) {
      this.DesignerName = '';
      this.DesignerEmail = '';
      this.CheckPurchaseDisabled()
    }
  }

  YardSelected(event: any, product: PublicOrderProductsResponse) {

    this.IsYardSelected = event.checked;

  }

  SetSelectedProduct(product: PublicOrderProductsResponse, billingCycle?: BillingRecurringTypes) {
    this.SelectedProduct = product;

    if (this.IsYardSelected == true && !this.YardAvailable(product))
      this.IsYardSelected = false;

    if (billingCycle) {
      this.SelectedBillingCycle = billingCycle;
    }
    this.SelectedPrice = product.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Price;
    this.SelectedSetupFee = product.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Setup;

    this.PriceDue = this.SelectedPrice + this.SelectedSetupFee - this.Credit;

    if (this.PriceDue < 0)
      this.PriceDue = 0;

    this.ProductSelected = true;
    this.CheckPurchaseDisabled();
    // this.CheckYardStatus();
    // this.simulateReactivation();
  }

  getNextBillDate(): Date {
    let newNextBillDate: Date = new Date();
    newNextBillDate.setMonth(newNextBillDate.getMonth() + 1);
    return newNextBillDate;
  }

  confirm() {
    // Confirm Action
    let request = new ReactivateRequestv2;
    request.LicenseKey = this.License.Key;
    request.Initials = 'reactivate';
    request.CreditCardID = Number(this.SelectedCreditCard);
    request.AdminID = this.gb.AdminID;
    request.BillingCycle = this.SelectedBillingCycle;
    request.IncludeYARD = this.IsYardSelected;
    request.NewProductID = this.SelectedProduct.ProductID;
    request.designerEmail = this.DesignerEmail;
    request.designerName = this.DesignerName;

    switch (this.KeyAssignment.value) {
      case 0:
        request.keepAssigned = true;
        break;
      case 1:
        request.assignToMember = true;
        break;
      case 2:
        request.assignToMember = false;
        break;
    }

    Swal.fire({
      title: 'Reactivate This License Key?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        // try to order
        return this.api.ProductsReactivatev2(request).toPromise();
      }
    }).then(
      async (response: any) => {
        this.gb.ClearOrderFormLocalStorage();

        if (response.isDismissed) {
          this.gb.ClearOrderFormLocalStorage();

          // show cancelled
          Swal.fire({
            title: 'Cancelled',
            text: 'No changes are saved.',
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000
          }).then(() => {
            this.close();
          }, () => { }); // keep this line to prevent promise error;
        } else if (!response.value || !response.value.Result) {
          Swal.fire(
            {
              title: 'Error',
              text: 'Error reactivating License Key',
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1500
            })
            .then(() => { }, () => { }); // keep this line to prevent promise error;
        } else {
          // show confirmation
          Swal.fire(
            {
              title: 'Success',
              text: 'Product Reactivated',
              icon: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1500
            })
            .then(() => {

            }, () => { }); // keep this line to prevent promise error;
        }
        this.result = true;
        this.close();
      },
      (dismiss) => {
        if (dismiss === 'cancel') {
          this.gb.ClearOrderFormLocalStorage();

          if (!confirm)
            return;

          // show cancelled
          Swal.fire({
            title: 'Cancelled',
            text: 'No changes are saved.',
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000
          }).then(() => {
            this.close();
          }, () => { }); // keep this line to prevent promise error;
        }
      }).catch(error => {
        Swal.fire(
          {
            title: 'Error',
            text: error.message,
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'OK',
          })
          .then((response: any) => {
            this.result = false;
            // this.IsBusy = false;
            this.close();
          }, (dismiss) => {
            // this.IsBusy = false;
            return;
          }); // keep this line to prevent promise error;
      });


  }

  cancel() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.gb.ClearOrderFormLocalStorage();
    this.result = false;
    this.close();
  }

  next() {
    this.currentModalStep = 2;
    this.simulateReactivation();
    // this.container.nativeElement.scrollTo(0, 0);
  }

  back() {
    this.currentModalStep = 1;
  }

  BillingTypeToString(type: BillingRecurringTypes) {
    return BillingRecurringTypes[type];
  }

  BillingTypeToPerString(type: BillingRecurringTypes) {
    if (type == BillingRecurringTypes.Monthly)
      return 'per Month';
    else
      return 'per Year';
  }

  InitialsChanged(data: string) {
    this.CheckPurchaseDisabled();
  }

  CheckDesignerFields() {
    if (this.DesignerFieldsHidden || (!this.DesignerFieldsHidden && (this.DesignerEmail != undefined && this.DesignerEmail.length > 1) && (this.DesignerName != undefined && this.DesignerName.length > 1))) {
      return true;
    } else {
      return false;
    }
  }

  CheckPurchaseDisabled() {
    if (this.ProductSelected && this.CreditCards.length > 0 && this.CheckDesignerFields())
      this.PurchaseDisabled = false;
    else
      this.PurchaseDisabled = true;
  }



  CreditCardChanged(e: any) {

  }

  recurringToString(myBillingCycle: BillingRecurringTypes): string {
    if (myBillingCycle == BillingRecurringTypes.Monthly)
      return 'Monthly';
    else
      return 'Yearly';
  }


  cardAdded({ cards, newCardId }: { cards: CreditCardResponseArray, newCardId: number }) {
    this.showAddCreditCard = false;
    this.updateCreditCardOptions(cards);
    this.SelectedCreditCard = newCardId;
    this.CheckPurchaseDisabled();
  }

  addCardCanceled() {
    this.showAddCreditCard = false;
  }

  updateCreditCardOptions(newCards: CreditCardResponseArray) {
    this.CreditCards = [];
    newCards.forEach(card => {
      this.CreditCards.push(
        {
          label: 'Name: ' + card.FirstName + ' ' + card.LastName +
            ' - Last four: ' + card.LastFour +
            ' - exp. Date: ' + card.ExpMonth + '/' + card.ExpYear,
          value: card.ID
        });
    });
  }


  GetCredit() {
    this.IsBusy = true;

    let subscription = this.api.MemberCredit().subscribe(response => {
      subscription.unsubscribe();
      this.IsBusy = false;
      this.Credit = response.Data;
    }, error => {
      subscription.unsubscribe();
      this.IsBusy = false;
    });

  }

  GetPriceDue(): number {
    let totalPriceDue: number = 0;

    if (this.simulationResponse) {
      totalPriceDue += this.simulationResponse.TotalWithTax;
      totalPriceDue -= this.Credit;
      if (totalPriceDue < 0 || Number.isNaN(totalPriceDue))
        totalPriceDue = 0;
    }

    return totalPriceDue;
  }

  CreditUsed(): number {
    if (this.simulationResponse && this.Credit > this.simulationResponse.TotalWithTax)
      return this.simulationResponse.TotalWithTax;
    else
      return this.Credit;
  }

  InCycleMessage() {
    if (this.IsInCycle) {
      Swal.fire({
        icon: 'warning',
        title: 'Active License',
        text: 'This license is still active until ' + moment(this.License.NextBillingDate).format('MMM DD, YYYY') + ' and cannot be modified. For more assistance, please contact support at  702-433-0274.',
        backdrop: false
      });
    }
  }

  getProductPrice(product: PublicOrderProductsResponse) {
    try {
      var productPrice = product.Prices.find(price => price.BillingCycle === this.SelectedBillingCycle).Price;

      var yardPrice = 0;

      if (this.YardAvailable(product) && this.IsYardSelected)
        yardPrice = product.YardAddon.Prices.find(price => price.BillingCycle === this.SelectedBillingCycle).Price;

      return productPrice + yardPrice;
    } catch (e) {

    }
    return 0;
  }

}
